export default function DTD_BuildingBlocks() {
  return (
    <div>
      <h1>DTD_BuildingBlocks</h1>
      <p>This is the DTD_BuildingBlocks component.</p>
    </div>
  );
}